import axiosInstance from '../api/axiosInstance';

export interface CompanyData {
  name: string;
  description?: string;
  avatar?: string;
  city: string;
  country: string;
  website?: string;
  businessType: string;
  address: string;
  phoneNumber: string;
}

export interface Company extends CompanyData {
  id: string;
  createdAt: string;
  updatedAt: string;
}

export const companyAPI = {
  // Create a new company
  createCompany: async (companyData: CompanyData): Promise<Company> => {
    const response = await axiosInstance.post('/companies', companyData);
    return response.data;
  },

  // Get company by ID
  getCompany: async (companyId: string): Promise<Company> => {
    const response = await axiosInstance.get(`/companies/${companyId}`);
    return response.data;
  },

  // Update company
  updateCompany: async (
    companyId: string,
    companyData: Partial<CompanyData>
  ): Promise<Company> => {
    const response = await axiosInstance.patch(
      `/companies/${companyId}`,
      companyData
    );
    return response.data;
  },

  // Delete company
  deleteCompany: async (companyId: string): Promise<void> => {
    await axiosInstance.delete(`/companies/${companyId}`);
  },

  // Get all companies (for admin)
  getAllCompanies: async (): Promise<Company[]> => {
    const response = await axiosInstance.get('/companies');
    return response.data;
  },
};
